import request from '@/config';
import { CounterpartSearch, CounterparCreate, CounterparDetail } from './counterpart.type';

import { useAppStoreWithOut } from '@/store/app';
const appStore = useAppStoreWithOut();

enum Apis {
	CreatePartyB = `/api/counterpart/insertcounterpart`,
	EditorPartyB = `/api/counterpart/updatecounterpart`,
	ErpSupplier = `/api/counterpart/GetSupplierDetail`,
	ErpCustom = `/api/counterpart/GetCustomList`,
	PartybDelete = `/api/counterpart/deletecounterpart`,
	GetDropDownList = `/api/counterpart/getdropdownlist`,
}

/* 相对方：新增 */
export const CreatePartybApi = (data: any): Promise<IResponse> => {
	return request.post({ url: Apis.CreatePartyB, data: data });
};

/* 相对方：修改 */
export const EditorPartybApi = (data: any): Promise<IResponse> => {
	return request.post({ url: Apis.EditorPartyB, data: data });
};

/* 相对方：获取Erp某个供应商详细数据 */
export const GetErpSupplierApi = (supplierNo: string): Promise<IResponse> => {
	return request.post({ url: Apis.ErpSupplier, data: { vonno: supplierNo } });
};

/* 相对方：获取Erp某个客户详细数据 */
export const GetErpCustomApi = (customNo: string): Promise<IResponse> => {
	return request.post({ url: Apis.ErpCustom, data: { custno: customNo } });
};

/* 相对方：删除(DELETE) */
export const CpDeleteApi = (data: any): Promise<IResponse> => {
	return request.post({ url: Apis.PartybDelete, data: data });
};

export const GetCpDropDownListApi = (search?: any): Promise<IResponse> => {
	return request.post({ url: Apis.GetDropDownList, data: { custno: search } });
};

/* 相对方：查询(LIST) */
export const GetCpListApi = (searchIpt: CounterpartSearch = { page_size: 10, current: 1 }): Promise<IResponse> => {
	return request.post({ url: '/api/Counterpart/GetCounterpartPage', data: searchIpt });
};

/* 相对方：查询(Detail) */
export const CpDetailApi = (rowId: string): Promise<IResponse> => {
	const login = appStore.getLoginInfo as LoginInfo;
	const searchIpt = {
		curr_user_id: login.user_id,
		tenant_id: '1',
		company_id: login.company_id,
		created_user_id: login.user_id,
		id: rowId,
	};

	return request.post({ url: '/api/counterpart/getcounterpartinfo', data: searchIpt });
};

/* 相对方：新增(CREATE) */
export const CpCreateApi = (createIpt: CounterparCreate): Promise<IResponse> => {
	return request.post({ url: '/api/counterpart/insertcounterpart', data: createIpt });
};

/* 相对方：修改(Editor) */
export const CpEditorApi = (createIpt: CounterparDetail): Promise<IResponse> => {
	return request.post({ url: '/api/counterpart/updatecounterpart', data: createIpt });
};

/* 相对方：更改使用状态 */
export const CtChgEnabledApi = (chgIpt: CounterparDetail): Promise<IResponse> => {
	const login = appStore.getLoginInfo as LoginInfo;
	const deleteDto = {
		curr_user_id: login.user_id,
		tenant_id: login.tenant_id,
		company_id: login.company_id,
		revision: chgIpt.revision,
		deleted_user_id: login.user_id,
		id: chgIpt.id,
		is_enabled: chgIpt.is_enabled,
	};

	return request.post({ url: '/api/counterpart/changeenable', data: deleteDto });
};
